module.exports = __webpack_public_path__ + "fonts/Montserrat-Bold.63fae50.ttf";